/* C4 — "You save" bulk-pricing readout for the Apippa (legacy) product page.
 *
 * Cathy, 15 Sep 2026: "the more you buy the more you save per unit. at the moment they can't
 * track what a customer would have paid without the bulk discounting." Wanted right in the Add
 * to cart button: the non-discounted amount with a red strikethrough, the real price, the cost
 * per unit, and "You save $X".
 *
 * THE NUMBER. "What they would have paid" = the unit rate at the SMALLEST quantity the calculator
 * offers, with every other option exactly as chosen, multiplied by the quantity chosen. So for
 * 500 double-sided cards it is (price of 100 double-sided cards / 100) x 500. The saving is that
 * minus the real price. Nothing is shown at the smallest quantity, or if the saving is not > 0.
 *
 * HOW IT IS COMPUTED, AND WHY IT CAN BE TRUSTED. Apippa keeps every number; this file never
 * writes one into the calculator or the cart. It re-runs Apippa's own formula engine -- a port of
 * calculator.js's FormulaParser / EvaluateFormulaElements / resolveLookupTables, read from the
 * deployed script on 15 Sep 2026 -- over the same DOM (.calc-prop fields) with ONE difference: the
 * Quantity field is read as if it held the smallest option. Before any figure is shown, the very
 * same engine is run WITHOUT that override, and its answer must equal Apippa's own current price
 * (#priceTicker[data-origMoney]) to the cent. If it does not -- an Apippa feature this port does
 * not know, a calculator shaped in some new way -- nothing is shown. A wrong saving on a print
 * job is worse than none.
 *
 * Inputs: the calculator config (Elements, Formula, MinimumValue) from Apippa's public config
 * endpoint -- the same GET the calculator itself makes, fetched once per page. The calculator id
 * is on #calculator[data-calcid].
 *
 * Output: fills [data-c4-cta-was] (strikethrough), [data-c4-cta-unit] (each-price) and
 * [data-c4-cta-save] inside the Add to cart button; c4-main-product.liquid's own sync script keeps
 * writing the total and each-price and is left in charge of those when this file has nothing to
 * say. Also mirrors the saving into hidden inputs `properties[You save]` and
 * `properties[Cost per unit]` on the form so the cart line and order carry it (Apippa posts the
 * whole form). Both are removed again when there is no saving to report.
 */
(function () {
  if (window.__c4YouSave) return;
  window.__c4YouSave = true;

  var form = document.querySelector('form[data-c4-legacy]');
  if (!form) return;

  var cfg = null;        /* Apippa config: { Elements, Formula, MinimumValue } */
  var cfgFailed = false;
  var productPrice = 0;  /* shopify_product_price, if a formula ever uses it */

  /* ---- config ------------------------------------------------------------------------------ */
  function shop() {
    try { return (window.Shopify && Shopify.shop) || ''; } catch (e) { return ''; }
  }
  function loadConfig() {
    if (cfg || cfgFailed) return;
    var calc = document.getElementById('calculator');
    var calcId = calc && calc.getAttribute('data-calcid');
    var pid = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || form.getAttribute('data-product-id') || '';
    if (!calcId || !pid) return;
    cfgFailed = true; /* one attempt; flipped back on success */
    var url = 'https://api.custompricecalculator.com/api/v1/calculator/app?calculatorId=' + encodeURIComponent(calcId) +
      '&productId=' + encodeURIComponent(pid) + '&isPreview=false&shop=' + encodeURIComponent(shop()) +
      '&productUrl=' + encodeURIComponent(location.origin + location.pathname) + '&locale=en';
    fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var d = j && j.calculatorData;
      if (!d || !d.Elements || !d.Formula) return;
      cfg = d;
      cfgFailed = false;
      try {
        var pm = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
        if (pm && pm.variants && pm.variants[0]) productPrice = (pm.variants[0].price || 0) / 100;
      } catch (e) {}
      schedule();
    }).catch(function () {});
  }

  /* ---- the engine (port of Apippa's parser) ------------------------------------------------ */
  function safeRegex(s) {
    var n = String(s).toLowerCase().replace(/[()\[\]?\/+$"'€£¥]/g, function (c) { return '\\' + c; });
    return new RegExp(n, 'g');
  }
  function isHidden(el) {
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
  function dataBool(el, k) { return el.getAttribute('data-' + k) === 'true'; }
  function elementByName(name) {
    for (var i = 0; i < cfg.Elements.length; i++) if (cfg.Elements[i].Name === name) return cfg.Elements[i];
    return null;
  }
  function elementByIdent(id) {
    for (var i = 0; i < cfg.Elements.length; i++) if (cfg.Elements[i].Identifier === id) return cfg.Elements[i];
    return null;
  }
  function props() {
    var a = [].slice.call(document.querySelectorAll('.calc-prop'));
    /* Longest identifier first, so "Size" never eats "Size (mm)". Mirrors Apippa's sort. */
    a.sort(function (x, y) {
      var ix = x.getAttribute('data-identifier'), iy = y.getAttribute('data-identifier');
      if (ix === null) return 1;
      if (iy === null || ix.length > iy.length) return -1;
      return 1;
    });
    return a;
  }

  /* override: Map(field element -> { value, index }) of fields to read AS IF they held another
     value (the baseline), or null. lookupVals: Map from lookup input element -> recomputed value. */
  function parse(formula, override, lookupVals) {
    var e = String(formula).toLowerCase();
    e = e.replace(/math\./g, 'Math.');
    e = e.split('shopify_product_price').join(String(productPrice));
    e = e.replace(/shopify_meta_(.*?)([*\/+-]|$)/g, '1$2');
    var lookups = {};
    props().forEach(function (u) {
      var S = u.getAttribute('data-identifier');
      if (S === null) return;
      var tag = u.tagName;
      var hidden = isHidden(u);
      var isLookup = u.hasAttribute('data-lookup');
      var isFormula = isLookup && dataBool(u, 'isformula');
      var A = false;
      if (isFormula) {
        var box = u.closest('.element');
        A = !box || box.style.display !== 'none';
      }
      var D = safeRegex(S);
      var val = function () {
        if (override && override.has(u)) return String(override.get(u).value);
        if (lookupVals && lookupVals.has(u)) return String(lookupVals.get(u));
        return u.value;
      };
      if (!hidden || A) {
        if (tag === 'SELECT') {
          var opt = (override && override.has(u)) ? u.options[override.get(u).index] : u.options[u.selectedIndex];
          e = e.replace(D, opt ? opt.getAttribute('data-val') : 'NaN');
        } else if (tag === 'INPUT' && dataBool(u, 'rangeenabled')) {
          var K = parseFloat(val());
          var J = K;
          var def = elementByIdent(S);
          if (def && def.options) def.options.forEach(function (o) {
            if (K >= parseFloat(o.start) && K <= parseFloat(o.end)) J = parseFloat(o.value);
          });
          e = e.replace(safeRegex(S + '[ActualValue]'), K);
          e = e.replace(D, parseFloat(J));
        }
        if (tag === 'TEXTAREA') {
          var t = val();
          if (!dataBool(u, 'lengthtoggle')) t = t.replace(/\s/g, '');
          e = e.replace(safeRegex(S + '[length]'), t.length);
        } else if (u.type === 'checkbox') {
          e = e.replace(D, u.checked ? u.getAttribute('data-checkedvalue') : u.getAttribute('data-uncheckedvalue'));
        } else if (u.type === 'radio') {
          if (u.checked) e = e.replace(D, u.getAttribute('data-val'));
        } else if (isLookup) {
          var idx = parseInt(u.getAttribute('data-lookupelementindex'), 10);
          var G = u.getAttribute('data-calcname');
          var W = lookups[S] || (lookups[S] = { elementName: S, input1_label: '', input1: 0, input2_label: '', input2: 0 });
          if (idx === 1) { W.input1 = parseFloat(val()); W.input1_label = G; }
          else if (idx === 2) { W.input2 = parseFloat(val()); W.input2_label = G; }
        } else if (tag !== 'SELECT' && !dataBool(u, 'rangeenabled')) {
          e = e.replace(D, parseFloat(val()));
        }
      } else {
        var def2 = elementByName(S);
        if (def2) {
          var K2 = def2.value_when_not_displayed;
          if (K2 === undefined) K2 = 1;
          if (tag === 'INPUT') e = e.replace(safeRegex(S + '[ActualValue]'), K2);
          e = e.replace(D, K2);
        }
        if (isLookup) {
          var idx2 = parseInt(u.getAttribute('data-lookupelementindex'), 10);
          var G2 = u.getAttribute('data-calcname');
          var def3 = elementByName(S);
          if (def3) {
            e = e.replace(safeRegex(S + '[' + G2 + ']'), 0);
            if (idx2 === 2) {
              var v2 = def3.value_when_not_displayed;
              if (v2 === undefined) v2 = 1;
              e = e.replace(D, parseFloat(v2));
            }
          }
        }
      }
    });
    return resolveLookups(e, lookups);
  }

  function resolveLookups(e, lookups) {
    for (var id in lookups) {
      var a = lookups[id];
      var o = elementByIdent(id);
      if (!o || !o.sheet_data) return 'NaN';
      e = e.replace(safeRegex(a.elementName + '[' + a.input1_label + ']'), a.input1);
      e = e.replace(safeRegex(a.elementName + '[' + a.input2_label + ']'), a.input2);
      var r1 = o.sheet_data.input1_range, r2 = o.sheet_data.input2_range;
      var u = r1.length - 1, f = r2.length - 1, m;
      for (m = 0; m < r1.length - 1; m++) if (parseFloat(a.input1) >= parseFloat(r1[m]) && parseFloat(a.input1) < parseFloat(r1[m + 1])) { u = m; break; }
      for (m = 0; m < r2.length - 1; m++) if (parseFloat(a.input2) >= parseFloat(r2[m]) && parseFloat(a.input2) < parseFloat(r2[m + 1])) { f = m; break; }
      if (u === 0 && parseFloat(a.input1) > parseFloat(r1[r1.length - 1])) u = r1.length - 1;
      if (f === 0 && parseFloat(a.input2) > parseFloat(r2[r2.length - 1])) f = r2.length - 1;
      var row = o.sheet_data.data_lookup[f];
      var p = row ? row[u] : undefined;
      if (p === undefined) return 'NaN';
      e = e.replace(safeRegex(id), p);
    }
    return e;
  }

  function evalExpr(src) {
    try { return Function('"use strict"; return (' + src + ');')(); } catch (e) { return NaN; }
  }

  /* Apippa's EvaluateFormulaElements: every .lookup-element-with-formula input is a formula of its
     own (e.g. "quantity"). Recompute each under the override, in DOM order, as Apippa does. */
  function evaluateLookups(override) {
    var vals = new Map();
    [].slice.call(document.querySelectorAll('.lookup-element-with-formula')).forEach(function (n) {
      var f = n.getAttribute('data-formula');
      var min = parseFloat(n.getAttribute('data-minvalue'));
      var v = evalExpr(parse(String(f), override, vals));
      vals.set(n, Math.max(isFinite(min) ? min : 0, v));
    });
    return vals;
  }

  /* noFloor: return the formula's own value without the calculator's MinimumValue. The baseline
     uses this: on per-m2 products a single small sign floors at the minimum ($80 corflute), and
     "10 x $80" would inflate the saving with a minimum-order charge that is not a unit rate. */
  function price(override, noFloor) {
    var vals = evaluateLookups(override);
    var expr = parse(cfg.Formula, override, vals);
    var v = evalExpr(expr);
    var min = parseFloat(cfg.MinimumValue);
    if (!isFinite(v)) return NaN;
    if (noFloor) return v;
    return Math.max(isFinite(min) ? min : 0, v);
  }

  /* ---- the quantity field and its smallest option ------------------------------------------- */
  function qtyField() {
    var f = document.querySelector('#calculator .calc-prop[name="properties[Quantity]"]');
    if (!f || isHidden(f)) return null;
    return f;
  }
  function qtyOf(f) {
    if (f.tagName === 'SELECT') {
      var o = f.options[f.selectedIndex];
      return o ? parseFloat(String(o.text).replace(/[^0-9.]/g, '')) : NaN;
    }
    return parseFloat(f.value);
  }
  /* Cards are quoted per card ACROSS all sets (Cathy, 15 Sep 2026): 250 cards x 4 variations is
     1000 cards. The saving is unaffected (sets are held constant); only the each-price divides by it. */
  function setsMultiplier() {
    var s = document.querySelector('#calculator select.calc-prop[name*="Variation"], #calculator select.calc-prop[name*="variation"], #calculator select.calc-prop[name*="sets"]');
    if (!s || isHidden(s)) return 1;
    var m = parseFloat(String(s.value).replace(/[^0-9.]/g, ''));
    return (isFinite(m) && m > 1) ? m : 1;
  }
  /* The baseline: the smallest quantity the calculator offers -- and, on products priced by area
     (Width/Height boxes with a Size dropdown of presets), ALSO the smallest preset size, one unit.
     Cathy, 16 Sep 2026: "its discounting on quantity and area" -- a single 2 m banner is already
     cheaper per m2 than an A1, so comparing it with "1 banner of the same size" hid the area
     discount. Returns { override: Map, units: <qty x m2 at the baseline>, qty, area } or null. */
  function baseline(f) {
    var ov = new Map();
    var baseQty;
    if (f.tagName === 'SELECT') {
      var best = -1, bestQ = Infinity;
      for (var i = 0; i < f.options.length; i++) {
        var q = parseFloat(String(f.options[i].text).replace(/[^0-9.]/g, ''));
        if (isFinite(q) && q > 0 && q < bestQ) { bestQ = q; best = i; }
      }
      if (best < 0) return null;
      ov.set(f, { index: best, value: bestQ });
      baseQty = bestQ;
    } else {
      var min = parseFloat(f.getAttribute('min'));
      if (!isFinite(min) || min <= 0) min = 1;
      ov.set(f, { value: min });
      baseQty = min;
    }
    var area = areaNow();
    var baseArea = null;
    if (area) {
      var sizeSel = document.querySelector('#calculator select.calc-prop[name="properties[Size]"]');
      var dims = null, bestA = Infinity;
      if (sizeSel) {
        for (var j = 0; j < sizeSel.options.length; j++) {
          var m = String(sizeSel.options[j].text + ' ' + sizeSel.options[j].value).match(/(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)/);
          if (!m) continue;
          var a = parseFloat(m[1]) * parseFloat(m[2]);
          if (isFinite(a) && a > 0 && a < bestA) { bestA = a; dims = m; }
        }
      }
      if (dims) {
        ov.set(area.w, { value: dims[1] });
        ov.set(area.h, { value: dims[2] });
        baseArea = bestA;
      } else {
        baseArea = area.value; /* no presets: quantity is the only baseline axis */
      }
    }
    return { override: ov, qty: baseQty, area: baseArea, units: baseQty * (baseArea || 1) };
  }
  /* Width/Height boxes when the product has them (both visible): { w, h, value: w x h }. */
  function areaNow() {
    var w = document.querySelector('#calculator input[name="properties[Width (mm)]"]');
    var h = document.querySelector('#calculator input[name="properties[Height (mm)]"]');
    if (!w || !h || isHidden(w) || isHidden(h)) return null;
    var a = (parseFloat(w.value) || 0) * (parseFloat(h.value) || 0);
    if (!(a > 0)) return null;
    return { w: w, h: h, value: a };
  }

  /* ---- output ------------------------------------------------------------------------------- */
  function money(n) {
    /* Same shape as the price beside it ($197.00), thousands separated. */
    var parts = (Math.round(n * 100) / 100).toFixed(2).split('.');
    return '$' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
  }
  /* "per card" / "per banner" / "per unit" from the button (c4-main-product.liquid derives it from
     the product); "each" only if the attribute is missing. */
  function unitWord() {
    var b = document.querySelector('[data-c4-cta]');
    var n = b && b.getAttribute('data-c4-unit-noun');
    return n ? ('per ' + n) : 'each';
  }
  function each(n) {
    return n < 1 ? (Math.round(n * 1000) / 10).toString().replace(/\.0$/, '') + 'c' : '$' + n.toFixed(2);
  }
  function setProp(name, value) {
    var inp = form.querySelector('input[name="properties[' + name + ']"][data-c4-save-prop]');
    if (value === null) { if (inp) inp.remove(); return; }
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + name + ']';
      inp.setAttribute('data-c4-save-prop', '');
      form.appendChild(inp);
    }
    if (inp.value !== value) inp.value = value;
  }

  /* Writes "<s>struck</s> <lead>" into an em slot -- the old rate struck out on the LEFT, the
     real one on the right (Cathy, 16 Sep 2026) -- only when it changed (observer-safe). */
  function setStruck(el, lead, struck) {
    var key = lead + '|' + struck;
    if (el.getAttribute('data-c4-txt') !== key) {
      el.textContent = '';
      var sEl = document.createElement('s');
      sEl.textContent = struck;
      el.appendChild(sEl);
      if (lead) el.appendChild(document.createTextNode(' ' + lead));
      el.setAttribute('data-c4-txt', key);
    }
    if (el.hidden) el.hidden = false;
  }
  /* The same row mirrored into the price block ([data-c4-price-rate]) and the mobile sticky bar
     ([data-c4-sticky-rate]): "<em><s>old</s> lead</em> <i>each-price</i>". The each-price is read
     from the button's own slot, which c4-main-product.liquid keeps current. Not the cart. */
  var MIRRORS = '[data-c4-price-rate], [data-c4-sticky-rate]';
  function mirrorRow(btn, lead, struck) {
    var unitEl = btn.querySelector('[data-c4-cta-unit]');
    var unit = (unitEl && !unitEl.hidden) ? (unitEl.textContent || '') : '';
    var key = lead + '|' + struck + '|' + unit;
    [].slice.call(document.querySelectorAll(MIRRORS)).forEach(function (el) {
      if (el.getAttribute('data-c4-txt') !== key) {
        el.textContent = '';
        var em = document.createElement('em');
        setStruck(em, lead, struck);
        el.appendChild(em);
        var i = document.createElement('i');
        i.textContent = unit;
        el.appendChild(i);
        el.setAttribute('data-c4-txt', key);
      }
      if (el.hidden) el.hidden = false;
    });
  }
  function hideMirrors() {
    [].slice.call(document.querySelectorAll(MIRRORS)).forEach(function (el) { if (!el.hidden) el.hidden = true; });
  }

  /* ---- "as low as" in the price block --------------------------------------------------------
     Cathy, 16 Sep 2026: "can you add the from as low as $... per unit in the price block". The best
     unit rate this calculator reaches with the OTHER options as chosen: the largest quantity option
     (or, for a number box, the best of 1/2/5/10/20/50) and, on area products, the largest preset.
     Real, floored prices -- a figure a customer can actually get to. Hidden if it is not at least
     1 % better than what they are looking at now. */
  function lowest(f) {
    var area = areaNow();
    var sizeSel = document.querySelector('#calculator select.calc-prop[name="properties[Size]"]');
    var bigDims = null, bigA = 0;
    if (area && sizeSel) {
      for (var j = 0; j < sizeSel.options.length; j++) {
        var m = String(sizeSel.options[j].text + ' ' + sizeSel.options[j].value).match(/(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)/);
        if (!m) continue;
        var a = parseFloat(m[1]) * parseFloat(m[2]);
        if (isFinite(a) && a > bigA) { bigA = a; bigDims = m; }
      }
    }
    var perM2 = !!(area && bigDims);
    var sets = setsMultiplier();
    var candidates = [];
    if (f.tagName === 'SELECT') {
      var best = -1, bestQ = 0;
      for (var i = 0; i < f.options.length; i++) {
        var q = parseFloat(String(f.options[i].text).replace(/[^0-9.]/g, ''));
        if (isFinite(q) && q > bestQ) { bestQ = q; best = i; }
      }
      if (best < 0) return null;
      candidates.push({ index: best, value: bestQ });
    } else {
      [1, 2, 5, 10, 20, 50].forEach(function (q) { candidates.push({ value: q }); });
    }
    var bestRate = Infinity;
    candidates.forEach(function (c) {
      var ov = new Map();
      ov.set(f, c);
      if (perM2) { ov.set(area.w, { value: bigDims[1] }); ov.set(area.h, { value: bigDims[2] }); }
      var p = price(ov, false);
      if (!isFinite(p) || p <= 0) return;
      var units = perM2 ? (c.value * bigA / 1e6) : (c.value * sets);
      var r = p / units;
      if (r < bestRate) bestRate = r;
    });
    if (!isFinite(bestRate)) return null;
    return { rate: bestRate, perM2: perM2 };
  }
  function renderLow(f, live, qty) {
    var el = document.querySelector('[data-c4-price-low]');
    if (!el) return;
    var low = lowest(f);
    if (!low) { if (!el.hidden) el.hidden = true; return; }
    var area = areaNow();
    var nowRate = low.perM2 && area ? live / (qty * area.value / 1e6) : live / (qty * setsMultiplier());
    if (!(nowRate > low.rate * 1.01)) { if (!el.hidden) el.hidden = true; return; }
    var txt = low.perM2 ? ('as low as ' + money(low.rate) + ' / m²') : ('as low as ' + each(low.rate) + ' ' + unitWord());
    if (el.textContent !== txt) el.textContent = txt;
    if (el.hidden) el.hidden = false;
  }

  function hideLow() {
    var lowEl = document.querySelector('[data-c4-price-low]');
    if (lowEl && !lowEl.hidden) lowEl.hidden = true;
  }
  /* clear() leaves the "as low as" line alone: it is most useful exactly when there is no rate
     story to tell on the button (the customer is at the minimum quantity). */
  function clear() {
    hideMirrors();
    var btn = document.querySelector('[data-c4-cta]');
    if (btn) {
      var was = btn.querySelector('[data-c4-cta-was]');
      var save = btn.querySelector('[data-c4-cta-save]');
      if (was && !was.hidden) was.hidden = true;
      if (save && !save.hidden) save.hidden = true;
      if (btn.hasAttribute('data-c4-saving')) btn.removeAttribute('data-c4-saving');
    }
    setProp('You save', null);
    setProp('Cost per unit', null);
    setProp('Rate per m2', null);
  }

  function render() {
    if (!cfg) { loadConfig(); return; }
    var btn = document.querySelector('[data-c4-cta]');
    var ticker = document.getElementById('priceTicker');
    var f = qtyField();
    if (!btn || !ticker || !f) { hideLow(); clear(); return; }
    /* Size not entered yet (c4-legacy.js's guard): the price on screen is a placeholder. */
    if (btn.hasAttribute('data-c4-size-wait')) { hideLow(); clear(); return; }

    var live = parseFloat(ticker.getAttribute('data-origMoney') || ticker.getAttribute('data-origmoney'));
    if (!isFinite(live) || live <= 0) { hideLow(); clear(); return; }

    /* Self-check: our engine must reproduce Apippa's own number before we say anything. */
    var mine = price(null);
    if (!isFinite(mine) || Math.abs(mine - live) > 0.005) { hideLow(); clear(); return; }

    var qty = qtyOf(f);
    if (isFinite(qty) && qty > 0) { try { renderLow(f, live, qty); } catch (e) {} }
    var base = baseline(f);
    if (!base || !isFinite(qty) || qty <= 0) { clear(); return; }
    var area = areaNow();
    var units = qty * (area && base.area ? area.value : 1);
    if (!(units > base.units * 1.0001)) { clear(); return; }

    var basePrice = price(base.override, true);
    if (!isFinite(basePrice) || basePrice <= 0) { clear(); return; }

    /* Rate per unit (per card, or per mm2 of banner) at the baseline, times what is being bought. */
    var undiscounted = (basePrice / base.units) * units;
    var saving = undiscounted - live;
    if (!(saving >= 1)) { clear(); return; }

    var was = btn.querySelector('[data-c4-cta-was]');
    var save = btn.querySelector('[data-c4-cta-save]');

    /* AREA PRODUCTS SHOW THE RATE, NOT A SAVING (Cathy, 16 Sep 2026: "square metre prices drop
       dramatically early on" -- against the A1 rate a 10 m2 banner "saved" $881, true but too good
       to be true on a button). So: "$42.00 / m2 (from $130 / m2)" -- the customer sees the curve
       without a headline dollar figure. No strikethrough, no "You save"; the each-price stays. */
    if (area && base.area) {
      var m2 = units / 1e6;
      var rate = live / m2;
      var baseRate = basePrice / (base.units / 1e6);
      if (!(m2 > 0) || !isFinite(rate) || !isFinite(baseRate) || !(baseRate > rate * 1.01)) { clear(); return; }
      if (was && !was.hidden) was.hidden = true;
      if (save) {
        /* "~~$130 / m²~~ $42.00 / m²" -- the original rate struck through in red (Cathy, 16 Sep). */
        setStruck(save, money(rate) + ' / m²', '$' + Math.round(baseRate) + ' / m²');
      }
      mirrorRow(btn, money(rate) + ' / m²', '$' + Math.round(baseRate) + ' / m²');
      if (!btn.hasAttribute('data-c4-saving')) btn.setAttribute('data-c4-saving', '');
      setProp('You save', null);
      setProp('Rate per m2', money(rate) + ' / m²');
      setProp('Cost per unit', qty > 1 ? each(live / qty) + ' ' + unitWord() : null);
      return;
    }
    setProp('Rate per m2', null);

    /* QUANTITY PRODUCTS: the same idea per unit (Cathy, 16 Sep 2026: "show the saving per unit
       rather"). "14.4c each (from 58c each)" -- the each-price the button already shows, with the
       minimum-quantity rate beside it. No strikethrough, no "You save" dollar figure. */
    var sets = setsMultiplier();
    var eachNow = live / (qty * sets);
    var eachBase = basePrice / (base.units * sets);
    if (!isFinite(eachNow) || !isFinite(eachBase) || !(eachBase > eachNow * 1.01)) { clear(); return; }
    if (was && !was.hidden) was.hidden = true;
    if (save) {
      /* "~~58c each~~ · 14.4c each" -- the each-price slot already shows the live figure. */
      setStruck(save, '', each(eachBase) + ' ' + unitWord());
    }
    mirrorRow(btn, '', each(eachBase) + ' ' + unitWord());
    if (!btn.hasAttribute('data-c4-saving')) btn.setAttribute('data-c4-saving', '');
    setProp('You save', null);
    setProp('Cost per unit', each(eachNow) + ' ' + unitWord());
  }

  /* ---- scheduling: cheap, debounced, guarded writes ------------------------------------------ */
  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; try { render(); } catch (e) { hideLow(); clear(); } }, 250);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#calculator')) setTimeout(schedule, 300);
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.closest && e.target.closest('#calculator')) schedule();
  }, true);
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.nodeType === 1 && t.closest && t.closest('[data-c4-cta]')) continue; /* our own writes */
        schedule(); return;
      }
    }).observe(document.body, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-origmoney', 'style', 'class'] });
  }
  var ticks = 0;
  var iv = setInterval(function () { schedule(); if (++ticks > 60) clearInterval(iv); }, 500);
  schedule();
})();
